export enum SuccessCode {
    // connect to cloud range
    ConnectionCreated = 1001,

    // link accounts range
    LinkedAccounts = 2001,

    // renew cloud session range
    RenewedCloudSession = 3001,

    // sharing range
    ShareCreated = 4001,
    ShareUpdated = 4002,
    ShareDeleted = 4003
}
